<span class="spinner" role="status" aria-label="Loading">
  <svg viewBox="0 0 100 100" class="spinner__svg">
    <!-- Circulo de fundo -->
    <circle class="spinner__track" cx="50" cy="50" r="45"></circle>

    <!-- Sessao giratoria do circulo -->
    <circle class="spinner__arc"   cx="50" cy="50" r="45"></circle>
  </svg>
</span>